import script from "./PhoneVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneVerification.vue?vue&type=script&setup=true&lang=js"

import "./PhoneVerification.vue?vue&type=style&index=0&id=644084c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644084c4"]])

export default __exports__